module.exports = __webpack_public_path__ + "5643600fc8a2721e20701057a21038fa.png";